import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  ReasonBean,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestReadRequest,
  RestSalesOrderListRequest,
  RestSalesOrderRequest,
  SalesOrderBean,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ReasonCaptureComponent,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { ModuleUtils } from "./ModuleUtils.js";
class CancelBackOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.cancelReasonDialogRef = React.createRef();
    this.state = {
      pageTitle: "Mass Cancel Back Order",
      isShowClearCriteriaButton: true,
      isShowExitButton: true,
      salesOrderLookupHandler: null,
      customerLookupHandler: null,
      reasonData: new ReasonBean(),
      cancelReasons: [],
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      criteria: new SalesOrderSearchCriteria(),
      salesOrderData: new SalesOrderBean(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isCancelDatasFound: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowSalesModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      companyCode: "",
      salesPageListForAutoCompleteList: new Array(),
      showAutoCompleteSOList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      backCancelSOList: new Array(),
      order: "asc",
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowClearErrorButton: false,
      isDisableFields: false,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };

    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.salesOrderCancelReasons;
    cancelReasons.map((ent) => {
      this.state.cancelReasons.push(ent);
    });
    this.initLookupHandlers();
    ModuleUtils.getSalesOrderStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrder"
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onSalesOrderChange = (e) => {
    let salesOrder = e.target.value;
    this.state.showAutoCompleteSOList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSOList;
    if (isEmpty(salesOrder)) {
      this.state.showAutoCompleteSOList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSOList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSOList: showAutoCompleteList,
        criteria: criteria,
        salesPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrder !== ""
    ) {
      this.readSalesBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readandsetSalesOrderDetail = (salesOrder) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = salesOrder;
    readrestInput.isLockRequired = true;
    SalesOrderService.initSalesOrderModule(
      readrestInput,
      this.editSalesOrderResponse,
      this.errorCallBack
    );
  };
  editSalesOrderResponse = (response) => {
    this.handleResponse(response.data);
    if (
      response.data.salesOrderResponse != null &&
      response.data.salesOrderResponse.salesOrder != null
    ) {
      let criteria = this.state.criteria;
      const salesOrder = response.data.salesOrderResponse.salesOrder;
      criteria.salesOrderNumber = salesOrder.code;
      this.setState({
        criteria: criteria,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readSalesBySearchString = (searchString) => {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderResponse,
      this.errorCallBack
    );
  };
  readBySalesOrderResponse = (response) => {
    let salesOrderData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderData.length > 0 && salesOrderData != null) {
      salesOrderData.map((salesCode) => {
        let simpleItemBean = {
          code: salesCode.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesCodeEnterKeyEventHandler = (e) => {
    let salesCode = e.target.value;
    this.readandsetSalesOrderDetail(salesCode);
    this.setState({
      salesPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSOList: showAutoCompleteList });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.criteria;
      tempData.customerCode = "";
      tempData.customerName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerByCustomerCodeResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Data...",
    });
    let customerData = response.data.customer;
    let criteria = this.state.criteria;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    this.setState({
      criteria: criteria,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.backOrderInclusionState = 1;
    let pageList = new PageListBean();
    let listRequest = new RestSalesOrderListRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageList;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Data...",
    });
    this.loadMassCancelBackOrderList(listRequest);
  };
  loadMassCancelBackOrderList = (listRequest) => {
    if (SecurityAccessManager.MassCancelBackOrders_IsAccessible()) {
      SalesOrderService.getSalesOrderPageList(
        listRequest,
        this.loadMassCancelBackOrderPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadMassCancelBackOrderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    let backCancelSOList = new Array();
    if (
      response.data != null &&
      response.data.salesOrderPageList != null &&
      !isEmptyArray(response.data.salesOrderPageList.salesOrders)
    ) {
      const salesOrders = response.data.salesOrderPageList.salesOrders;
      salesOrders.map((ln) => {
        if (
          ln.orderStatus == LogicConstants.SALES_ORDER_APPROVE_STATUS ||
          ln.orderStatus == LogicConstants.SALES_ORDER_UNAPPROVE_STATUS
        ) {
          backCancelSOList.push(ln);
        }
      });
      this.setState({
        isCancelDatasFound: true,
        backCancelSOList: backCancelSOList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
      });
      this.disable();
    }

    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.loadPage(1);
    this.clearError();
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      salesPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
    });
  };
  resetView = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isCancelDatasFound: false,
      backCancelSOList: new Array(),
      salesPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  cancelBackOrder = (e, rowData) => {
    if (e.detail == 1) {
      let salesOrderData = new SalesOrderBean();
      salesOrderData.orderStatus = rowData.orderStatus;
      salesOrderData.companyCode = this.companyCode;
      salesOrderData.code = rowData.code;
      this.setState({
        reasonData: new ReasonBean(),
        salesOrderData: salesOrderData,
      });
      this.lockCancelBackOrder(rowData.code, true);
      this.openReasonCapture(1);
    }
  };
  onCancelReasonContinue = () => {
    this.cancelBackOrderContinue();
    this.closeReasonModelCallBack();
  };
  handleCancelResponse = (response) => {
    let isSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.infos != null) {
      response.infos.map(
        (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
      );
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      isSuccess = true;
    }
    if (response.errors != null) {
      response.errors.map(
        (err) => (
          (errMsg = errMsg + "\n" + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      isSuccess = false;
    }
    return isSuccess;
  };
  cancelBackOrderResponse = (response) => {
    let isSuccess = this.handleCancelResponse(response.data);
    if (isSuccess) {
      if (response.data != null && response.data.salesOrder != null) {
        let criteria = response.data.salesOrder;
        if (criteria !== null) {
          this.unlockCancelBackOrder(criteria.code, true);
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  cancelBackOrderContinue = () => {
    let salesorderdata = this.state.salesOrderData;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.code = salesorderdata.code;
    input.isLockRequired = true;
    input.salesOrderBean = salesorderdata;
    input.reason = this.state.reasonData;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    if (SecurityAccessManager.MassCancelBackOrders_IsAccessible()) {
      SalesOrderService.cancelSalesOrder(
        input,
        this.cancelBackOrderResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  unlockCancelBackOrder = (code, isNew) => {
    let data = new RestEntityUnLockRequest();
    data.companyCode = this.companyCode;
    data.entityCode = code;
    data.isNew = isNew;
    SalesOrderService.unLockSalesOrder(
      data,
      this.unlockCancelBackOrderResponse,
      this.errorCallBack
    );
  };
  unlockCancelBackOrderResponse = (response) => {
    this.loadPage(1);
  };
  lockCancelBackOrder = (code, isNew) => {
    let data = new RestEntityUnLockRequest();
    data.companyCode = this.companyCode;
    data.entityCode = code;
    data.isNew = isNew;
    SalesOrderService.lockSalesOrder(
      data,
      this.lockCancelBackOrderResponse,
      this.errorCallBack
    );
  };
  lockCancelBackOrderResponse = (response) => {};

  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let backCancelSOList = this.state.backCancelSOList;
    if (sortField && !isEmptyArray(backCancelSOList)) {
      const sorted = [...backCancelSOList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ backCancelSOList: sorted });
    }
  };
  render() {
    let backCancelSOList = this.state.backCancelSOList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          isShowExitButton={this.state.isShowExitButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          pageTitle={this.state.pageTitle}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          execute={this.execute}
          reset={this.resetView}
          clearCriteria={this.clearCriteria}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          onSalesOrderChange={this.onSalesOrderChange}
          salesCodeEnterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
          displayAutoCompleteSalesList={this.displayAutoCompleteSalesList}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        />
        {this.state.isCancelDatasFound && (
          <>
            <Row>
              <FormLabel className="table_title">
                BackOrder Cancel List
              </FormLabel>
            </Row>
            <div className="div_default">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "customerCode")
                      }
                    >
                      Customer
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "customerName")
                      }
                    >
                      CustomerName
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "salesOrderNumber")
                      }
                    >
                      SalesOrder#
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "orderStatus")
                      }
                    >
                      Status
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStatus" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "orderStartDate")
                      }
                    >
                      StartDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStartDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingChange(e, "orderStopDate")
                      }
                    >
                      StopDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderStopDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                {this.state.isCancelDatasFound && (
                  <tbody>
                    {backCancelSOList.map((data, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCustomerModule(e, data.customerCode)
                            }
                          >
                            {data.customerCode}
                          </Button>
                        </td>
                        <td>{data.customerName}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.viewSalesModule(e, data.code)}
                          >
                            {data.code}
                          </Button>
                        </td>
                        <td className="summary_input">
                          {ModuleUtils.getSalesOrderStatusCaption(
                            data.orderStatus
                          )}
                        </td>
                        <td>{data.orderStartDate}</td>
                        <td>{data.orderStopDate}</td>
                        <td>
                          {" "}
                          <Button
                            size="sm"
                            id="fabric_Add_Button"
                            onClick={(e) => this.cancelBackOrder(e, data)}
                          >
                            Cancel Back Order
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              {backCancelSOList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          </>
        )}
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="CancelBackOrder Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const onCustomerCodeChange = (e) => props.onCustomerCodeChange(e);
  const customerCodeEnterKeyEventHandler = (e) =>
    props.customerCodeEnterKeyEventHandler(e);
  const displayAutoCustomerCompleteList = (list) =>
    props.displayAutoCustomerCompleteList(list);
  const onSalesOrderChange = (e) => props.onSalesOrderChange(e);
  const salesCodeEnterKeyEventHandler = (e) =>
    props.salesCodeEnterKeyEventHandler(e);
  const displayAutoCompleteSalesList = (showAutoCompleteList) =>
    props.displayAutoCompleteSalesList(showAutoCompleteList);
  let criteria = props.criteria;
  let salesOrderLookupHandler = props.salesOrderLookupHandler;
  let customerLookupHandler = props.customerLookupHandler;
  let customerCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={onCustomerCodeChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCustomerCompleteList}
            showAutoCompleteList={props.isShowAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            type="text"
            onChange={onChange}
            value={criteria.customerName}
            readOnly={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder From Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDatefrom"
            value={criteria.orderStopDatefrom}
            onChange={onChange}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel> Sales Order Number </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onSalesOrderChange}
            name="salesOrderNumber"
            value={criteria.salesOrderNumber}
            lookupRequired={true}
            lookupHandler={salesOrderLookupHandler}
            enterKeyEventHandler={salesCodeEnterKeyEventHandler}
            autoCompleteListData={props.salesPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesList}
            showAutoCompleteList={props.showAutoCompleteSOList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder To Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDateTo"
            value={criteria.orderStopDateTo}
            onChange={onChange}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
      </Row>
    </div>
  );
}
function CancelBackOrderModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CancelBackOrder {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default CancelBackOrderModule;
